/* =====================================================================
   GARVIN · LISTADO DE COLECCIÓN — Fase 5 · 16/10/2026
   Lo carga sections/main-collection-product-grid.liquid (defer).
   1) «Ver más productos»: añade la página siguiente sin recargar, por encima
      del botón (los agotados quedan al final por CSS order) y desplaza la
      vista al primer producto nuevo.
   2) Flecha «Volver» de la cabecera móvil.
   ===================================================================== */
(() => {
  if (window.__garvinLoadMore) return;
  window.__garvinLoadMore = true;

  // «Ver más productos»: pide la página siguiente de esta sección y añade sus tarjetas a la cuadrícula.
  // Delegado en document: sigue funcionando cuando filtros u ordenar redibujan la cuadrícula.
  const markRoots = () => {
    document.querySelectorAll('[data-garvin-loadmore]').forEach((root) => root.classList.add('garvin-loadmore-on'));
  };
  markRoots();
  document.addEventListener('DOMContentLoaded', markRoots);

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest && event.target.closest('[data-garvin-more-btn]');
    if (!btn) return;
    const box = btn.closest('[data-garvin-more]');
    const grid = box && box.parentElement;
    if (!box || !grid || btn.disabled) return;

    btn.disabled = true;
    box.classList.add('is-loading');
    try {
      const url = new URL(box.dataset.nextUrl, window.location.origin);
      url.searchParams.set('section_id', box.dataset.section);
      const html = await fetch(url.toString()).then((r) => {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      });
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.getElementById('product-grid');
      if (!newGrid) throw new Error('grid');

      const added = [];
      newGrid.querySelectorAll(':scope > .collection__grid__item').forEach((item) => {
        item.classList.remove('scroll-trigger', 'animate--slide-in');
        grid.insertBefore(item, box);
        added.push(item);
      });

      // Llevar a la vista el primer producto nuevo (el primero disponible; si todos están agotados,
      // el primero añadido), justo bajo el header fijo, para seguir bajando desde ahí.
      const target = added.find((item) => !item.classList.contains('garvin-soldout')) || added[0];
      if (target) {
        requestAnimationFrame(() => {
          const header = document.querySelector('header.page-header');
          const offset = (header ? header.getBoundingClientRect().height : 0) + 12;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
        });
      }

      const nextBox = newGrid.querySelector('[data-garvin-more]');
      if (nextBox) {
        box.dataset.nextUrl = nextBox.dataset.nextUrl;
        const count = box.querySelector('[data-garvin-more-count]');
        const nextCount = nextBox.querySelector('[data-garvin-more-count]');
        if (count && nextCount) count.textContent = nextCount.textContent;
        btn.disabled = false;
        box.classList.remove('is-loading');
      } else {
        box.remove();
      }
    } catch (e) {
      // Si falla, se va a la página siguiente de la forma normal
      window.location.href = box.dataset.nextUrl;
    }
  });
})();



(() => {
  if (window.__garvinCollectionBack) return;
  window.__garvinCollectionBack = true;

  // Volver: a la pantalla anterior si venimos de la tienda; si no, al enlace del botón
  document.addEventListener('click', (event) => {
    const back = event.target.closest && event.target.closest('[data-garvin-col-back]');
    if (!back) return;
    let sameSite = false;
    try {
      sameSite = document.referrer && new URL(document.referrer).origin === window.location.origin;
    } catch (e) {}
    if (sameSite && window.history.length > 1) {
      event.preventDefault();
      window.history.back();
    }
  });
})();
